/**
 * Visual palette, copy, and layout for the announcement modal. Dark-committed
 * (the app renders single dark mode). See specs/in-app-announcements/spec.md §7.
 */

export const ANNOUNCEMENT_MODAL_COLORS = {
  CARD_BG: '#16181D',
  CARD_BORDER: 'rgba(255,255,255,0.08)',
  HEADING: '#FFFFFF',
  BODY: '#C7CBD1',
  CLOSE_BG: 'rgba(255,255,255,0.08)',
  CLOSE_ICON: '#E6E8EB',
  BUTTON_PRIMARY_BG: '#33D17A',
  BUTTON_PRIMARY_TEXT: '#0B0D10',
  BUTTON_SECONDARY_BG: 'rgba(255,255,255,0.10)',
  BUTTON_SECONDARY_TEXT: '#FFFFFF',
} as const;

export const ANNOUNCEMENT_MODAL_COPY = {
  /** Accessible name for the modal + fallback dismiss control. */
  A11Y_TITLE: 'Announcement',
  A11Y_CLOSE: 'Close announcement',
} as const;

export const ANNOUNCEMENT_MODAL_LAYOUT = {
  MAX_CARD_WIDTH: 380,
  /** Cap the scrollable content so a long message never runs off small screens. */
  MAX_CONTENT_HEIGHT: 560,
} as const;
